import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Overlay } from 'react-overlays';
import { OwnerSmallIcon, ModeratorSmallIcon } from '../icons';
import Tooltip from '../tooltip';
import scrollParent from '../../services/scroll-parent';
import { ROLE_OWNER, ROLE_ADMIN, ROLE_MODERATOR } from '../../services/permissions-checker';
import withTranslate from '../../hoc/with-translate';
import styles from './badge.scss';

const BADGES = {
  [ROLE_OWNER]: OwnerSmallIcon,
  [ROLE_ADMIN]: OwnerSmallIcon,
  [ROLE_MODERATOR]: ModeratorSmallIcon,
};

class Badge extends Component {
  state = {
    isTooltipVisible: false,
  };

  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.timeout = setTimeout(() => {
      this.setState({
        isTooltipVisible: true,
      });
    }, 250);
  }

  handleMouseLeave() {
    clearTimeout(this.timeout);
    this.setState({
      isTooltipVisible: false,
    });
  }

  render() {
    const { className, role, t } = this.props;
    const Icon = BADGES[role];
    if (Icon) {
      return (
        <div
          className={classNames(styles.container, className, 'badge')}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          data-hook="badge"
        >
          <Icon className={classNames(styles.icon, 'forum-icon-fill')}/>
          <Overlay
            show={this.state.isTooltipVisible}
            placement="top"
            container={scrollParent()}
            target={this}
            onHide={this.handleMouseLeave}
            rootClose
          >
            <Tooltip>
              {t(`badge.${role}`)}
            </Tooltip>
          </Overlay>
        </div>
      );
    }
    return null;
  }
}

Badge.propTypes = {
  className: PropTypes.string,
  role: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslate(Badge);



// WEBPACK FOOTER //
// ./app/components/badge/badge.js